export default "__VITE_ASSET__ENndfSms__"